/**
 * @generated SignedSource<<fa486c935fa750f95352218e9551561f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PaymentCheckoutHeading_checkout$data = {
  readonly company: {
    readonly nameFriendly: string | null | undefined;
  } | null | undefined;
  readonly value: number | null | undefined;
  readonly " $fragmentType": "PaymentCheckoutHeading_checkout";
};
export type PaymentCheckoutHeading_checkout$key = {
  readonly " $data"?: PaymentCheckoutHeading_checkout$data;
  readonly " $fragmentSpreads": FragmentRefs<"PaymentCheckoutHeading_checkout">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PaymentCheckoutHeading_checkout",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "value",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Company",
      "kind": "LinkedField",
      "name": "company",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "nameFriendly",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Checkout",
  "abstractKey": null
};

(node as any).hash = "6125f36c3aea75daf72ba91b04c34cb7";

export default node;
